'use es6';
export const API_BASE_URL = "https://c4citk6s9k.execute-api.us-east-1.amazonaws.com/prod/data";
export const ELASTICSEARCH_URL = "https://c4citk6s9k.execute-api.us-east-1.amazonaws.com/prod/elastic";
export const AUTH_URL = "https://gfvyo7vst4.execute-api.us-east-1.amazonaws.com/default/CritiqueAuthTest";